import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { AuthContext } from '../../context/auth'
import apinode from '../../services/apinode'

import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import { Botao } from '../../components/Botao'
import { CustomInput } from '../../components/CustomInput'
import { CustomMask } from '../../components/CustomMask'
import { CustomSpinner } from '../../components/CustomSpinner'
import { isPhone } from '../../utils/isPhone'
import { Container, Error, Form, FormContent, Image, Success } from './styles'

import ReCAPTCHA from 'react-google-recaptcha'
import { toast } from 'react-toastify'
import officeJpg from '../../assets/images/office.jpg'

function Login() {
  const [usuario, setUsuario] = useState('')
  const [senha, setSenha] = useState('')
  const [sucesso, setSucesso] = useState('')
  const { setLogado } = useContext(AuthContext)
  const [cnpjempresa, setCnpjEmpresa] = useState('')
  const [cnpj, setCnpj] = useState('')
  const [isRequestLoading, setIsRequestLoading] = useState(false)
  const [isRequestLoginLoading, setIsRequestLoginLoading] = useState(false)
  const [captchaValido, setCaptchaValido] = useState(false)
  const [ip, setIp] = useState('')

  const navigate = useNavigate()

  // Buscar IP público do usuário
  useEffect(() => {
    async function fetchIP() {
      try {
        const res = await fetch('https://api.ipify.org?format=json')
        const data = await res.json()
        setIp(data.ip)
      } catch (error) {
        console.error('Erro ao buscar IP:', error)
      }
    }

    fetchIP()
  }, [])

  async function userCompanyVerification() {
    setIsRequestLoading(true)

    try {
      const response = await apinode.get('/auth/cnpj', {
        params: { cnpj },
      })

      localStorage.setItem('idconta', response.data.idconta)
      localStorage.setItem('nomeconta', response.data.razaosocial)
      localStorage.setItem('usa_wms', response.data.usa_wms.trim())
      setCnpjEmpresa(response.data.razaosocial)
    } catch (err) {
      setCnpjEmpresa('')
      setSucesso('N')
    } finally {
      setIsRequestLoading(false)
    }
  }

  async function handleSubmit(e) {
    e.preventDefault()

    if (!captchaValido) {
      toast.warning('Confirme o CAPTCHA!')
      return
    }

    try {
      setIsRequestLoginLoading(true)

      const response = await apinode.get(
        `/auth/login/${localStorage.idconta}`,
        {
          params: {
            usuario,
            senha,
            conta: localStorage.idconta,
          },
        },
      )

      localStorage.setItem('logado', 'S')
      localStorage.setItem('idusuario', response.data.id_usuario)
      localStorage.setItem('username', response.data.nome)
      localStorage.setItem('admin', response.data.admin)
      localStorage.setItem('cnpj', cnpj)
      localStorage.setItem('access', btoa(senha))

      setLogado(true)
      setSucesso('S')
      navigate('/')
    } catch (err) {
      setLogado(false)
      localStorage.setItem('logado', 'N')
      setSucesso('N')
      toast.error('Erro ao fazer login!')
    } finally {
      setIsRequestLoginLoading(false)
    }
  }

  return (
    <Container>
      <Helmet>
        <meta
          name="description"
          content="Desbloqueie o potencial máximo do seu negócio online com a nossa solução de integração de marketplaces..."
        />
        <title>Login</title>
      </Helmet>

      <Form onSubmit={handleSubmit}>
        <FormContent>
          <img src="../Images/logo.png" />

          <CustomMask
            format="##.###.###/####-##"
            icon="File"
            placeholder="CNPJ da empresa"
            value={cnpj}
            onChange={(e) => setCnpj(e.target.value)}
            onBlur={userCompanyVerification}
          />

          <CustomInput
            icon="UserCircle"
            placeholder="Usuário"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
          />

          <CustomInput
            icon="Lock"
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            isPassword
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSubmit(e)
              }
            }}
          />

          <ReCAPTCHA
            sitekey="6Lep2VorAAAAAKs25T7S78rGLlDJYv3ZmyY3nt4M"
            onChange={async (token) => {
              try {
                const response = await apinode.post('/verify-captcha', {
                  token,
                })

                if (response.data.success) {
                  console.log('Captcha verificado com sucesso!')
                  setCaptchaValido(true)
                } else {
                  console.log('Captcha inválido!')
                  setCaptchaValido(false)
                }
              } catch (err) {
                console.error('Erro ao verificar captcha:', err)
                setCaptchaValido(false)
              }
            }}
          />

          <Botao
            type="submit"
            color="#0d6efd"
            icon="DoorOpen"
            title="Acessar"
            isLoading={isRequestLoginLoading}
            // isDisabled={!usuario || !senha || !cnpjempresa}
            isDisabled={!usuario || !senha || !cnpjempresa || !captchaValido}
          />

          <p style={{ marginTop: 10, fontSize: '0.9rem', color: '#666' }}>
            Seu IP: {ip}
          </p>
        </FormContent>

        {isRequestLoading ? (
          <CustomSpinner
            size={30}
            style={{ marginTop: 20 }}
          />
        ) : cnpjempresa ? (
          <Success>
            <CheckCircleFill
              size={20}
              color="#0e6655"
            />
            <p>{cnpjempresa}</p>
          </Success>
        ) : sucesso === 'N' ? (
          <Error>
            <XCircleFill
              size={20}
              color="#a93226"
            />
            <p>CNPJ não informado ou inexistente</p>
          </Error>
        ) : null}
      </Form>

      {!isPhone && <Image $image={officeJpg} />}
    </Container>
  )
}

export default Login
